import React, {
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    Select,
    List,
    Button,
    Grid,
    Skeleton
} from 'antd';

import * as T from 'utils/types';
import TotalResult from "components/panel/TotalResult";
import { smtPubTabThunks } from "./SmtPubTabSlice";
import Error500 from "components/errors/Error500";
import SmtPublicationTitle from "components/smtPublication/SmtPublicationTitle";
import SmtPublicationDescription from "components/smtPublication/SmtPublicationDescription";
import "../PubTab/AltmetricBadge.css"
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';

const {Option} = Select;

// google scholar publication tab
export default () => {
    const dispatch = useDispatch();


    // useEffect(() => {
    //     // _altmetric_embed_init is offered by Altmetric in embeded.js file
    //     // this func will let js to find new altmetric-embed div and fetch the data for them
    //     // eslint-disable-next-line
    //     eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    // })

    const {
        searchInput,
        keywordType,
        facultyID,
        departmentID,
        searchTab,
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    // below section is been commented because we decide to never sort the pubs acoording to rank (relevance)
    // we only sort based on either date or Altmetric score

    // // we do this because '-rank' can only be used when search using keywords
    // useEffect(()=>{
    //     if(sortType!=="-altmetric_score"){
    //         if(keywordType==="match" ){ // means search using name
    //             sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //         }
            
    //         if(keywordType==="search"){ // means search using keywords
    //             if(searchInput===''){ // if searchInput is empty, sort the pub using date
    //                 sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //             }else{ // if searchInput is not empty, sort the pub using rank
    //                 sortType!=="-rank" && dispatch(searchPgUserInputsS.actions.setSortType("-rank"));
    //             }
    //         }
    //     }
    // }, [dispatch, searchInput, keywordType, sortType]);

    const {
        total,
        status,
        hasNext,
        smtPubList,
    } = useSelector((state: T.RootState) => state.smtPubTab);



    useEffect(()=>{
        searchTab === T.SearchTab.SMT_PUBLICATIONS && dispatch(smtPubTabThunks.initList({
            keywordType, searchInput,
            facultyID, departmentID,
        }));
    }, [
        keywordType, searchInput,
        facultyID, departmentID,
        dispatch, searchTab,
    ]);

    const screens = Grid.useBreakpoint();
    const breakpoint = screens.xs;

    return <>
        {total>=0&&status==="succeeded"&&<TotalResult searchResult={total}/>}

        {breakpoint && <br />}

        {/* 
            below section is been commented out because we decide to never sort the pubs acoording to rank (relevance)
            we only sort based on either date or Altmetric score 
        */}

        {/* {(searchInput===''||keywordType==="match")&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-date') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-date')
                    );
                }
            }}>
            Sort by date {sortType === '-date' && '\u2193'}
        </Button>}
        {searchInput!==''&&keywordType==="search"&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-rank') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-rank')
                    );
                }
            }}>
            Sort by relevance {sortType === '-rank' && '\u2193'}
        </Button>} */}





        {status!=="failed"&&<List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(smtPubTabThunks.loadMore())}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={smtPubList}
            renderItem={ item => {
                const pub = item.item as T.SmtPublication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            // avatar={<div
                            //         className='altmetric-embed'
                            //         data-badge-type='donut'
                            //         data-badge-popover="right"
                            //         data-link-target='_blank'
                            //         data-doi={pub?.doi||"0"}
                            //     ></div>}

                            title={ <SmtPublicationTitle smtPub={pub}/> }

                            description={ <SmtPublicationDescription smtPub={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />}
        
        { status==="failed"&&<Error500/> }




    </>;
}